import get from 'lodash/get';

import { AppRootState } from '../../../store/models/app-state.model';

export const getSearchTerm = (
  state: AppRootState,
  featureFilters: string,
  nameFilter: string
): string => {
  return get(state, `${featureFilters}.filters.header.${nameFilter}`);
};
